export type TBreadcrumb = {
  label: string;
  active: boolean;
  href: string;
  level: number;
}

export interface IBreadCrumbState {
  breadcrumbs: TBreadcrumb[]
}

export const UpdateBreadCrumbAction: string = "update-breadcrumb-action";

export type IHistory = {
  history: string[]
}

/* history */
export const UpdateHistoryAction: string = "update-history-action";
